import TagManager from 'react-gtm-module';

let isGtmActive = false;

type TGTMProps = {
  gtmId: string;
};

type TGTMEvent = 'signup-success' | 'db-connected' | 'sample-db-connected';

const pushEvent = (event: TGTMEvent, data?: any): void => {
  //  @ts-expect-error:  Property 'dataLayer' does not exist on type 'Window & typeof globalThis'
  const windowDataLayer = window.dataLayer;
  if (!isGtmActive) return;

  if (!data) {
    windowDataLayer.push({
      event,
    });
    return;
  }
  windowDataLayer.push({
    event,
    ...data,
  });
};

const googleTagManager = {
  init: ({ gtmId }: TGTMProps): void => {
    if (gtmId) {
      TagManager.initialize({
        gtmId,
      });

      isGtmActive = true;
    }
  },
  signupSuccess: () => {
    pushEvent('signup-success');
  },
  databaseConnected: () => {
    pushEvent('db-connected');
  },
  databaseSampleConnected: () => {
    pushEvent('sample-db-connected');
  },
};

export default googleTagManager;
